// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__17dQC","col":"styles_col__1v5Pd","fulfillmentStatus":"styles_fulfillmentStatus__2v35J","emailCol":"styles_emailCol__9WqX1"};